(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/services/services/fetch-player-competition-draws.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/services/services/fetch-player-competition-draws.js');

const trinidad = svs.isServer ? require('@svenskaspelab/trinidad-core').core : svs.core;
const { PromiseStatus } = svs.isServer ?
  require('../../constants/assets/javascripts/promise-status.es6') :
  svs.components.marketplaceCompetition.constants.promiseStatus;
const { settleRequestsSerially } = svs.isServer ?
  require('../../constants/assets/javascripts/settle-requests-serially.es6') :
  svs.components.marketplaceCompetition.constants.settleRequestsSerially;
const { jupiter } = trinidad;
const logger = svs.isServer ? trinidad.logger('marketplace-competition:services') : trinidad.log.getLogger('marketplace-competition:services');

const fetchPlayerCompetitionDraws = async (playerCompetitionsIds, req) => {
  try {
    const paths = playerCompetitionsIds.map((compId) => `/player/1/competitions/${compId}/drawstatus`);
    const structurePlayerCompetitionsDraws = {};
    const responses = await settleRequestsSerially(paths.map((path) => () => jupiter.callAsync({
      method: 'GET',
      path,
      req
    })));
    responses.forEach((response, key) => {
      const competitionId = playerCompetitionsIds[key];

      if (response.status === PromiseStatus.Rejected) {
        logger.info(`Mkp-competition: Failed fetching player competition draw status for ${competitionId}: ${response.reason?.message || response.reason}`, req);
        return;
      }

      const value = response.value;

      if (value.hasOwnProperty('error')) {
        logger.info(`Mkp-competition: Failed fetching player competition draw status for ${competitionId}: ${value.error?.message || JSON.stringify(value.error)}`, req);
        return;
      }
      structurePlayerCompetitionsDraws[competitionId] = value.participatedDraws;
    });
    return structurePlayerCompetitionsDraws;
  } catch (err) {
    logger.info(`Mkp-competition: Error fetching player competition draws: ${err}`, req);
    throw err;
  }
};
if (svs.isServer) {
  module.exports = fetchPlayerCompetitionDraws;
} else {
  setGlobal('svs.components.marketplaceCompetition.services.services.fetchPlayerCompetitionDraws', fetchPlayerCompetitionDraws);
}


 })(window);